
































































import { Component, Mixins } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";
import PortalOfficeReviewSearchBox from "@/components/jobsearch/PortalOfficeReviewSearchBox.vue";
import { PortalOfficeReviewSearchParams } from "@/components/jobsearch/PortalOfficeReviewSearchBox.vue";

import AxiosMixin from "@/mixins/axiosMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import PortalOfficeReviewTable from "@/views/jobsearch/PortalOfficeReviewTable.vue";
import { PortalOfficeReview } from "@/model/portal";

@Component({
  components: {
    AppTextField,
    PortalOfficeReviewSearchBox,
    AppAuthButton,
    PortalOfficeReviewTable,
  },
})
export default class extends Mixins(AxiosMixin) {
  private searchKey = ""; //絞り込み文字列

  /** タブ情報 */
  private currentTab = 0;

  private unapprovedReviews: PortalOfficeReview[] = [];
  private approvedReviews: PortalOfficeReview[] = [];
  private rejectedReviews: PortalOfficeReview[] = [];

  private fetchList(searchObj: PortalOfficeReviewSearchParams): void {
    this.postJsonCheck(
      window.base_url + "/api/admin/portal_office_reviews/get",
      searchObj,
      (res) => {
        this.unapprovedReviews = res.data.unapproved_reviews || [];
        this.approvedReviews = res.data.approved_reviews || [];
        this.rejectedReviews = res.data.rejected_reviews || [];
      }
    );
  }
}
